import { useContext, useEffect, useState } from "react";
import { Accordion, Button, Form } from "react-bootstrap";
import { AuthContext } from "../contexts/AuthContext";
import { AddPost, DeletePost, QueryPosts, UpdateAck } from "../databases/posts";
import { TITLE } from "../databases/spName";
import BlockContainer from "../components/BlockContainer";
import { SelectForm, TextForm } from "../components/FormItem";

const PagePosts = () => {

    const [posts, setPosts] = useState({})
    const [addingPost, setAddingPost] = useState({
        admin : '',
        content : '',
        title : '',
        flight : 0,
    })
    const { owndata, userRole } = useContext(AuthContext)

    //const unsub = useRef(null);

    useEffect(() => {
        return () => {
            setPosts({})
            setAddingPost({
                admin : '',
                content : '',
                title : '',
                flight : 0,
            })
        }
    }, [])

    useEffect(() => {
        const unsub = QueryPosts(userRole, setPosts)
        return () => {
            unsub()
        }
    }, [userRole])

    const setCheck = async (e, id) => {
        const c = e.target.checked
        await UpdateAck(c, id)
    }


    const renderPosts = () => {
        if (posts) return Object.entries(posts).sort((a, b) => a[1].ms > b[1].ms ? -1 : 1).map((v, index) => (
            <Accordion.Item 
                eventKey={index} key={index} 
                hidden={!userRole && v[1].flight !== 0 && String(owndata.round) !== String(v[1].flight)}
            >
                <Accordion.Header>
                    <div className={userRole ? '' : v[1].isRead ? 'text-success' : 'text-danger'}>{`[${v[1].date}] ${v[1].title}`}</div>
                </Accordion.Header>
                <Accordion.Body>
                    <div className="text-end">{v[1].flight ? `เฉพาะเที่ยวบิน ${v[1].flight}, ` : ''}by {v[1].admin}, อ่านแล้ว {[...v[1].ack].length} คน</div>
                    <span style={{whiteSpace : 'pre-line'}}>{v[1].content}</span>
                    <br />
                    <br />
                    <div hidden={userRole}>
                        <Form.Check 
                             checked={v[1].isRead || false} label=' อ่านแล้ว' name={`form-check-${v[0]}`} id={`form-check-${v[0]}`}
                            onChange={e => setCheck(e, v[0])} 
                        />
                        
                    </div>
                    <Button variant="danger" hidden={!userRole} onClick={() => onDeleteClick(v[0])}>ลบ</Button>
                </Accordion.Body>
            </Accordion.Item>
        ))
    }

    const onAddClick = async () => {
        await AddPost({...addingPost})
            .then(() => {
                setAddingPost({
                    admin : '',
                    content : '',
                    title : '',
                    flight : 0,
                })
                alert('เพิ่มประกาศสำเร็จ')
            })
            .catch(() => {
                alert('เกิดข้อผิดพลาด')
            })
    }

    const onDeleteClick = async (id) => {
        await DeletePost(id)
            .then(() => alert('ลบข้อมูลสำเร็จ'))
            .catch(() => alert('เกิดข้อผิดพลาด'))
    }

    return (
        <div>
            <div className="bold">ประกาศปัจจุบัน</div>
            
            <Accordion>
                {renderPosts()}
            </Accordion>
            <br />
            <div hidden={!userRole}>
                <div className="bold">เขียนประกาศ</div>
                <BlockContainer>
                    <TextForm value={addingPost.title} title='หัวข้อ' onChange={e => setAddingPost({...addingPost, title : e.target.value})}/>
                    <TextForm value={addingPost.admin} title='โดย' onChange={e => setAddingPost(p => ({...p, admin : e.target.value}))}/>
                    <SelectForm value={addingPost.flight} title='แสดงให้เห็นเฉพาะ' onChange={e => setAddingPost(p => ({...p, flight : e.target.value}))} options={TITLE.round.options}/>
                    
                    <div>เนื้อหา</div>
                    <Form.Control as="textarea" style={{minHeight : '200px'}} value={addingPost.content} onChange={e => setAddingPost(p => ({...p, content : e.target.value}))} />
                    <Button onClick={onAddClick}>เพิ่ม</Button>
                </BlockContainer>
            </div>
            
        </div>
    )

}

export default PagePosts;